import styled from 'styled-components'

export const Card = styled.div`
    display:flex;
    margin: 10px 10px 10px 0;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    @media (min-width: 768px) { 
        
    }
    @media (min-width: 992px) { 
        
    }
    @media (min-width: 1200px) { 
        
    }
   

`
export const ContentLink = styled.div`
    display: flex;
    flex-direction: column;

    a{
        display: flex;
        flex-direction: column;
    

        img{
            width: 100%;
        }
    }
    
`

export const Title = styled.div`
    font-size :16px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #D9A76A;
    
    
`

export const Linkover = styled.a`
    display:flex;
    
    &:hover .titlelink{
        color:#D9A76A
    }
    
`

export const Desc = styled.div`
    font-size: 16px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;

    div{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        flex-direction: row;

        div{
            display: flex; 
            flex-direction: column; 
        }

        span{
            margin-right: 10px;
            font-size: 12px;
        }
    }
`

export const Info = styled.div`
    padding:10px;
`

export const TxtDate = styled.span`
    margin-right: 20px;
    font-size: 12px;
    padding-left: 14px;
`

export const Separador = styled.div`
    border-bottom:#EAEAEA solid 1px;
    margin: 14px 0;
    
    
`
export const Cont = styled.div`
    width:100%;
    box-shadow: 0px 2px 2px #00000029;
    background-color: #fff;
	  -webkit-transition: 
		background-color 300ms linear,
			   color 300ms linear;
	
    border-radius: 6px;
    display:flex;
    justify-content: space-between;
    margin-bottom:20px;
    margin: 10px;

    :hover{
        background-color: rgba(217, 167, 106,.6); 

    }
    @media (min-width: 768px) { 
        width:48%;  
    }
    @media (min-width: 992px) { 
        width:30%;
    }
    @media (min-width: 1200px) { 
        width:30%;
    }
    
    
`









